import React from 'react';
import Pattren from '../../../Assets/images/Pattrens/footer.webp';
import './PerfectSolution.scss';
import { NavLink } from 'react-router-dom';

const PerfectSolutionAr = () => {

    return (
       <section dir='rtl' className='aug-perfec-solution'>
            <div className='container'>
                <div className='aug-perfec-solution-wrap'>
                    <div className='row align-items-center'>
                        <div className='offset-lg-2 col-lg-6 col-md-12 col-12'>
                            <div className='aug-perfec-solution-box'>
                                <h2 className='mb-3'>استكشف الحل الأمثل لمتطلباتك في المجال السريري</h2>
                                <p>لا حاجة إلى بطاقة ائتمان.<br />
                                لا توجد رسوم مقابل التنفيذ والتدريب.</p>
                                <NavLink to="/ar/contact-sales" className="btn btn-primary">تحدَّث إلى خبير</NavLink>
                            </div>
                        </div>
                        <div className='col-lg-4 col-md-12 col-12'>
                            <div className='aug-perfec-solution__img'>
                                <img src={Pattren} alt="pattern" className="img-fluid"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
       </section>
    );
};

export default PerfectSolutionAr;